import { useEffect, useState } from 'react';

interface BotDetectionResult {
  isBot: boolean;
  isSuspicious: boolean;
  isReady: boolean;
}

export const useBotProtection = (): BotDetectionResult => {
  const [result, setResult] = useState<BotDetectionResult>({ 
    isBot: false, 
    isSuspicious: false,
    isReady: false 
  });

  useEffect(() => {
    const detectBot = () => {
      const checks = {
        // Selenium, Puppeteer automation tools
        webDriver: navigator.webdriver === true,
        
        // Headless Chrome
        headlessChrome: /HeadlessChrome/.test(navigator.userAgent),
        
        // PhantomJS
        phantom: !!(window as any).callPhantom || !!(window as any)._phantom,
        
        // AI bot User-Agent patterns
        aiBot: /GPTBot|ClaudeBot|Bytespider|CCBot|anthropic|Perplexity|Diffbot|Meta-ExternalAgent|cohere-ai|Amazonbot/i.test(navigator.userAgent),
        
        // Missing language settings (suspicious)
        noLanguages: !navigator.languages || navigator.languages.length === 0,
        
        // Zero viewport dimensions
        suspiciousViewport: window.outerWidth === 0 || window.outerHeight === 0,
      };

      const isBot = checks.webDriver || checks.phantom || checks.aiBot || checks.headlessChrome;
      const isSuspicious = checks.noLanguages || checks.suspiciousViewport;

      // Delay ready state to timeout crawlers
      setTimeout(() => {
        setResult({
          isBot,
          isSuspicious,
          isReady: true
        });
      }, 1500);
    };

    detectBot();
  }, []);

  return result;
};
